﻿import { LiveDataSet } from "./LiveDataSet";

var BASE_URL = '/api/LiveData';

export function getLiveData(callback: (err: any, data: LiveDataSet) => any): void {
    $.ajax(BASE_URL + '', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data: LiveDataSet, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(errorThrown, null);
        }
    });
}